import { pickBy, isEmpty } from "lodash";

import { revoke } from "../session";
import * as sessionSelectors from "../session/selectors";
import apiConfig from "./config";
export { uploadPosterImageDataUrl } from "./uploadPosterImage";

export const exceptionExtractError = exception => {
  if (!exception.Errors) return false;
  let error = false;
  const errorKeys = Object.keys(exception.Errors);
  if (errorKeys.length > 0) {
    error = exception.Errors[errorKeys[0]][0].message;
  }
  return error;
};

export const fetchApi = async (
  endPoint,
  { body, method = "GET", version = "v1", headers = {}, signal } = {
    method: "GET",
    version: "v1",
    headers: {},
  },
) => {
  const accessToken = sessionSelectors.get().token;
  const auth = accessToken ? { Authorization: `Bearer ${accessToken}` } : {};

  try {
    const res = await fetch(`${apiConfig[version]}${endPoint}`, {
      method,
      body,
      signal,
      headers: pickBy(
        {
          ...auth,
          ...headers,
        },
        item => !isEmpty(item),
      ),
    });

    if (res.status >= 400) throw res;
    const data = await res.json();
    return data;
  } catch (err) {
    if (err.status === 401) {
      revoke();
    }

    if (err.status === 409) {
      throw err;
    }

    try {
      const res = await err.json();
      throw new Error(res.message ?? `Fetch failed with status ${err.status}`);
    } catch (e) {
      throw err;
    }
  }
};
